export default "/images/android__page_heading.png";